export default __webpack_public_path__ + "static/part1_3mb-94b078133ba1cd80bc7f25c593b23d7d.png";